import { AnalyticsState, AutomationFilter } from 'apps/performanceAnalytics/store/types'

export const buildContentStatisticsQuery = ({
  period,
  contentType,
  automation,
  sortField,
  sortOrder,
}: AnalyticsState['query']) => ({
  period,
  content_type: contentType ?? undefined,
  has_automation:
    automation === AutomationFilter.ALL ? undefined : automation === AutomationFilter.WITH,
  sort: sortField ?? undefined,
  order: sortOrder ?? undefined,
})
